export const ACL_DEFAULT_CONFIG = {
  guard_url: `accessdenied`,
};
